/**
 * GraphQL Query
 * ダウンロード画面
 */

/**
 * ダウンロードファイル管理一覧
 */
export const GRAPH_QL_QUERY_DOWNLOAD_CONTROLS =
`
query {
  downloadControl {
    uuid,
    templateDisplayValue,
    searchConditionRefKey,
    filePath,
    condition,
    statusCode,
    createdAt
  }
}
`
/**
 * ダウンロードファイル管理単体
 */
export const GRAPH_QL_QUERY_DOWNLOAD_CONTROL =
`
query {
  downloadControl ( ? ) {
    uuid,
    templateDisplayValue,
    filePath,
    condition,
    statusCode,
    createdAt
  }
}
`

/**
 * ダウンロードテンプレ
 */
export const GRAPH_QL_QUERY_DOWNLOAD_TEMPLATE =
`
query {
  downloadTemplate {
    id,
    displayValue,
    permissionConfigRefKey,
    searchConditionRefKey,
    note
  }
}
`



// WEBPACK FOOTER //
// ./src/queries/download.js